<template>
  <div>
    <div v-if="hasError" class="error-boundary">
      <div class="min-h-[200px] flex items-center justify-center p-4">
        <div class="text-center">
          <div class="mb-4 text-red-500">
            <svg 
              class="mx-auto h-12 w-12" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                stroke-linecap="round" 
                stroke-linejoin="round" 
                stroke-width="2" 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">
            {{ errorTitle || $t('errorBoundary.defaultTitle') }}
          </h3>
          <p class="text-gray-600 mb-4">
            {{ errorMessage || $t('errorBoundary.defaultMessage') }}
          </p>
          <button
            @click="resetError"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {{ $t('errorBoundary.retryButton') }}
          </button>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'ErrorBoundary',
  props: {
    errorTitle: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hasError: false,
      error: null
    }
  },
  methods: {
    resetError() {
      this.hasError = false
      this.error = null
      this.$emit('reset')
    }
  },
  errorCaptured(err, vm, info) {
    this.hasError = true
    this.error = err
    console.error('Error captured:', err, info)
    return false // Prevent error from propagating
  }
}
</script> 